<template>
  <div class="infinity-icon" />
</template>

<style scoped lang="scss">
@use "assets/styles/global/variables" as v;

.infinity-icon {
  height: 20px;
  width: 20px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url("/assets/images/svg/infinity-icon.svg");

  @media screen and (min-width: v.$desktop) {
    height: 26px;
    width: 26px;
  }
}
</style>